import { React, useEffect, useState } from "react";
import NavBarV2 from "../../NavBarV2";
import Card from "react-bootstrap/Card";
import Paper from "@mui/material/Paper";
import Logo from "../../../assets/dashboard-img1.svg";
import Logo1 from "../../../assets/Arrow_04.svg";
import Logo2 from "../../../assets/dashboard-img2.svg";
import Logo3 from "../../../assets/dashboard-img3.svg";
import Logo4 from "../../../assets/Arrow_04-down.svg";
import AddIcon from "@mui/icons-material/Add";
import TableContainer from "@mui/material/TableContainer";
import Tab from "@mui/material/Tab";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import moment from "moment";
import Worklogo from "../../../assets/dashboardworkspace.svg";
import CardContent from "@mui/material/CardContent";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { InputAdornment, TextField } from "@mui/material";
import Table from "react-bootstrap/Table";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import "../../../WorkSpace/SignUp2.css";
// import AddCompanyModal from "../Modal/editCompanyModal";
import "../../../WorkSpace/font.css";
import Tabsystem from "../../Workspace-v2/Tabsystem";
import Tabs from "@mui/material/Tabs";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popover from "@mui/material/Popover";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Navbar } from "../../../Components/Navbar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import swal from "sweetalert";
import InvestmentModal from "../Modal/investmentModal";
import { IrRegister } from "../../../Console/Component/services/apiHandler";
import Autocomplete from "@mui/material/Autocomplete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import addTeamMemberIcon from "./../../../../src/assets/Image/workspaceIcon/addtmember.svg"
import duplicateIcon from "./../../../../src/assets/Image/workspaceIcon/duplicate.svg"
import renameIcon from "./../../../../src/assets/Image/workspaceIcon/rename.svg"
import deleteIcon from "./../../../../src/assets/Image/workspaceIcon/delete.svg"
import RenameSVGComponent from "../../../Components/Common/SVGComponents/RenameSVGComponent";
import SendApproval from "../Modal/sendApproval";
import SendRequest from "../Modal/sendRequest";

// import { motion } from "motion/react"
import { motion } from "framer-motion";



import commoncss from "../../../myfin_v2/css/common.module.css";
import cardcss from "../../../myfin_v2/css/card.module.css";
import { ReactComponent as CreateWSCard } from "../../../myfin_v2/assets/icons/create_ws_card.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/search.svg";
import { ReactComponent as ExpandIcon } from "../../../myfin_v2/assets/icons/expand.svg";
import { ReactComponent as RightArrowIcon } from "../../../myfin_v2/assets/icons/rightArrowEcl.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import StatusIndicator from "../../../myfin_v2/elements/StatusIndicator"


import {
  AllWorkspace,
  DuplicateWorkspace,
  WorkspaceUpdate,
  checkDeleteAccess,
  cities,
  createWorkspaceName,
  deleteIr,
  deleteWorkspace,
  renameWorkspace,
  state,
} from "../ApiServices/apiHandler";
import { useHistory } from "react-router";
import { fetchWorkspace } from "../../../redux/actions/workspace/actionAllWrokspace";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import showDeleteConfirmation from "../../../helper/alertConfirmMessage";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 789,
  height: 451,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};

const WorkSpaceData = (props) => {
  const {
    nextStep,
    handleClickData,
    allAcessWorkspace,
    workspace,
    UserName,
    WorkSpaceAll,
    workspaceCy,
    workspacePy,
    allIr,
    nextWorkspace,
    handleOpenInvestment,
    company,
    a11yProps,
    handleClicktab,
    CustomTabPanel,
    setAllIR,
  } = props;
  const dispatch = useDispatch();
  const users = JSON.parse(localStorage.getItem('user'));
  const permissions = JSON.parse(localStorage.getItem('permission'));
  const [value, setValue] = useState(0);
  const [Irid, setId] = useState("");
  const [WSPID, setWSp] = useState("");
  const [WID, setWID] = useState("");
  const [WSPDATA, setWspData] = useState("");
  const [openRenameModal, setOpenRenameModal] = useState(false);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [openRequestModal, setOpenRequestModal] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [rename, setName] = useState("");
  const [renameId, setRenameID] = useState("");
  const [approverId, setApproverId] = useState("");
  const [companyId, setCompanyIds] = useState([]);
  const all_workSpace = useSelector((state) => state.AllWSReducer);
  const allWorkspace = all_workSpace.response;


  useEffect(() => {
    if (!dataFetched) {
      dispatch(fetchWorkspace());
      setDataFetched(true);
    }
  }, [dataFetched]);


  let history = useHistory();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setId(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenRenameModal(false);
  };

  const handleApproverChange = (event) => {
    setApproverId(event.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const opentab = Boolean(anchorE2);
  const idtab = opentab ? "simple-popover" : undefined;

  const handleDeleteIr = async (Ir_id) => {
    const res = await deleteIr(Ir_id);
    if (res.status === 200) {
      setAllIR();
      setAnchorEl(null);
    }
  };
  const handleOpenApprovalModal = () => setOpenApproveModal(true);
  const handleCloseApprovalModal = () => setOpenApproveModal(false);

  const handleOpenRequestModal = () => setOpenRequestModal(true);
  const handleCloseRequestModal = () => setOpenRequestModal(false);

  const handleClosetab = () => {
    setAnchorE2(null);
  };
  const handleEditIr = (ir_id) => {
    console.log(ir_id, "uuuu");
    history.push(`/investmentregisterv2/${ir_id}`);
  };

  const handleSelectIr = (ir_id) => {
    history.push(`/insideworkspace/${ir_id}`);
  };

  const CompanyName = (c_id) => {
    const result = company.filter((adj) => adj._id === c_id);
    return result[0]?.company_name;
  };

  const handleClickWsp = (event, id, data) => {
    setAnchorE2(event.currentTarget);
    setWSp(id);
    setWspData(data);
  };

  const handleViewOnly = async (workspace_id, check) => {
    if (check === "on") {
      let data = {
        access_status: "view",
      };
      const res = await WorkspaceUpdate(data, workspace_id);
      if (res.status === 200) {
        console.log("success");
        swal("", "View Access On", "success");
        setAnchorE2(false);
        dispatch(fetchWorkspace());
      }
    } else if (check === "off") {
      let data = {
        access_status: "off",
      };
      const res = await WorkspaceUpdate(data, workspace_id);
      if (res.status === 200) {
        console.log("success");
        swal("", "View Access Off", "success");
        setAnchorE2(false);
        dispatch(fetchWorkspace());
      }
    }
  };
  const handleChangeData = (e) => {
    setName(e.target.value);
  };
  const submitCompany = async () => {
    const data = {
      workspaceName: rename,
    };
    const result = await renameWorkspace(renameId, data);
    if (result.status === 200) {
      swal("Success", "Workspace Renamed Successfully", "success");
      setAnchorE2(false);
      setOpenRenameModal(false);
      WorkSpaceAll().then(res => {
        dispatch(fetchWorkspace());
      }).catch(err => { })
    }
    console.log(result.data);
    if (result.data.status === false) {
      swal("", result.data.message, "error");
    }
  };
  const handleDuplicate = async (workspace_id) => {
    if (users.responsibilities === "approver" || users.responsibilities === "view") {
      swal("warning", "You don't have access to duplicate", "warning");
    } else {
      const res = await DuplicateWorkspace(workspace_id);
      if (res.status === 200) {
        dispatch(fetchWorkspace());
      }
      handleClosetab();
    }
  };
  const handleAddTeam = (workspace_id) => {
    if (users.responsibilities === "approver" || users.responsibilities === "view") {
      swal("warning", "You don't have access to add Team Member", "warning");
    } else {
      history.push(`/inviteteammember/${workspace_id}`);
    }
  };
  const handleRename = (workspace_id) => {
    if (users.responsibilities === "approver" || users.responsibilities === "view") {
      swal("warning", "You don't have access to rename workspace", "warning");
      return;
    }
    setOpenRenameModal(true);
    setRenameID(workspace_id);
  };

  const shareUser = (id) => {
    try {
      const nameAcess = allAcessWorkspace.filter(
        (adj) => adj.workspace_id === id
      );
      const result = nameAcess?.email ? nameAcess?.email : "";
      return result.slice(0, 2);
    } catch (error) {
      console.log(error, "2222");
      return 0;
    }
  };

  const handleDelete = async (w_id) => {
    swal({
      title: "Are you sure",
      text: " you want to delete this workspace?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, archive it!",
      cancelButtonText: "No, cancel please!",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async (result) => {
      if (result === true) {
        const res = await deleteWorkspace(w_id);
        if (res.status === 200) {
          dispatch(fetchWorkspace());
          setAnchorE2(false);
        }
      }
    });
  };

  const checkingPermission = async (w_id) => {
    const workspace_id = w_id;
    checkDeleteAccess(workspace_id)
      .then(response => {
        if (response.data.missingCompanies.length === 0) {
          handleOpenApprovalModal();
          setWID(w_id);
        } else if (response.data.missingCompanies.length === response.data.approvedCompanies.length) {
          handleOpenApprovalModal();
          setWID(w_id);
        } else {
          swal("", "You Don't have full access to delete Workspace", "warning");
          handleOpenRequestModal();
          setWID(w_id);
          setCompanyIds(response.data.missingCompanies);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };



  return (
    <>
      {all_workSpace.loading && !all_workSpace.response ? (
        <div className="dahboardHeaderV2">
          <div className="row">
            <div className="col-12 text-center" style={{ paddingTop: "100px" }}>
              <CircularProgress />
            </div>
          </div>
        </div>
      ) : all_workSpace.isSuccess && all_workSpace.response.length > 0 ? (
        <>
          <div>
            <div className={`${commoncss.dFlex}`} style={{
              position: "sticky",
              top: "0",
              zIndex: "10",
              padding: "15px 7px"
            }}>
              <motion.span initial={{ x: -200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.heading2}>My Workspace  </motion.span>

              <motion.span initial={{ x: 300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 100, opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}><SearchIcon className="mr-3" /><ExpandIcon className={commoncss.clickable} onClick={nextWorkspace} /></motion.span>
            </div>
            {/* <div style={{ "padding": "10px" }}> */}

            {/* <div className="row" style={{ paddingTop: "10px" }}> */}
            {/* <div className="col-12"> */}
            <motion.div initial={{ x: 300, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 100, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }} className="row mt-2 mb-2" style={{ "gap": "10px", "place-content": "center" }}>
              {permissions?.companyData[0]?.components[0]?.permission?.create === true || permissions === null ? (
                <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }}>
                  <CreateWSCard width="14vw" height="230" className={commoncss.clickable} onClick={nextStep} style={{ "width": "14vw" }} />
                </motion.span>
              ) : (
                <motion.span initial={{ scale: 0 }} animate={{ scale: 1 }}>
                  <CreateWSCard width="14vw" height="230" className={commoncss.filterGreyScale} disabled style={{ "width": "14vw" }} />
                </motion.span>
              )
              }
              {allWorkspace.slice(0, 4).map((det) => {
                return (
                  <>
                    <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className={`${cardcss.wsCard} ${commoncss.clickable}`} onClick={() => handleClickData(det._id)}>
                      <div className={`${cardcss.wsHeadingMin} ${commoncss.dFlexJustifysb} ${cardcss.wsCardSelModules}`} >

                        {det.workspace_name ? det.workspace_name?.length > 16 ? (
                          <div class="rtooltip" >{det.workspace_name.substring(0, 14).concat('...')}
                            <span class="rtooltiptext" style={{ "width": "185px" }}>{det.workspace_name}</span>
                          </div>
                        ) : (
                          det.workspace_name
                        ) :
                          workspace(det.workspace_id, "id")
                        }
                        {/* {det.workspace_name ? (
                          <>
                            {det.workspace_name}
                          </>
                        ) : (
                          <>
                            {workspace(det.workspace_id, "id")}
                          </>

                        )} */}
                        <span className={cardcss.editDiv} onClick={(e) => { e.stopPropagation() }}>
                          {/* {det.access ? det.access === "Edit" ?
                                                          <span className="font-inter rename-icons">
                                                            <RenameSVGComponent height={14} width={14} color={'#32a899'} style={{ marginBottom: "2px", marginRight: "2px" }} />
                                                            CAN EDIT
                                                          </span> :
                                                          <span className="font-inter view-icons">
                                                            <VisibilityIcon style={{ fontSize: "14", color: "#5d615f", marginBottom: "1px", marginRight: "2px" }} />VIEW ONLY</span>
                                                          : ""} */}
                          <EditIcon width={16}
                            onClick={(e) => { e.stopPropagation(); handleClickWsp(e, det._id, det) }}
                            style={{ cursor: "pointer" }}
                          />

                          <Popover
                            style={{ left: "-103px" }}
                            id={idtab}
                            open={opentab}
                            anchorEl={anchorE2}
                            onClose={handleClosetab}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                          >
                            <Typography className="mt-2" sx={{}}>
                              {/* <span
                                                                                      style={{
                                                                                        cursor: "pointer",
                                                                                        fontSize: "12px",
                                                                                      }}
                                                                                      onClick={() =>
                                                                                        handleViewOnly(WSPID, "off")
                                                                                      }
                                                                                    >
                                                    
                                                                                      <div className="viewIcon">
                                                                                        <VisibilityIcon className="mt-1 ml-3" style={{ width: "18px", height: "18px", color: "black" }} />
                                                                                        <span className="mt-1 ml-1 font-sans">View Only</span>
                                                                                      </div>
                                                                                    </span> */}
                              <br />
                              {WSPDATA.access_status === "view" ? (
                                <span
                                  className="font-sans "
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    color: "grey",
                                  }}
                                >
                                  {"Add Team Member"}
                                </span>
                              ) : (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  onClick={(e) => { e.stopPropagation(); handleAddTeam(WSPID) }}
                                >
                                  <div className="view-options">
                                    <img
                                      className="icon-img ml-3"
                                      src={addTeamMemberIcon}
                                      alt="Add Team Member Icon"
                                      style={{
                                        filter: "grayscale(100%)",
                                      }}
                                    />
                                    <span className="mt-1 ml-1 font-sans ">Add Team Member</span>
                                  </div>
                                </span>
                              )}
                              <br />
                              {WSPDATA.access_status === "view" ? (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    color: "grey",
                                  }}
                                >
                                  {"Duplicate"}
                                </span>
                              ) : (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  onClick={(e) => { e.stopPropagation(); handleDuplicate(WSPID) }}
                                >
                                  <div className="view-options">
                                    <img className="icon-img ml-3"
                                      src={duplicateIcon}
                                      alt="Duplicate icon"
                                    />
                                    <span className="mt-1 ml-1 font-sans ">Duplicate</span>
                                  </div>
                                </span>
                              )}
                              <br />
                              {WSPDATA.access_status === "view" ? (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    color: "grey",
                                  }}
                                >
                                  {"Rename"}
                                </span>
                              ) : (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  onClick={(e) => { e.stopPropagation(); handleRename(WSPID) }}
                                >
                                  <div className="view-options">
                                    <img className="icon-img ml-3"
                                      src={renameIcon}
                                      alt="rename icon"
                                    />
                                    <span className="mt-1 ml-1 font-sans ">Rename</span>
                                  </div>
                                </span>
                              )}
                              <br />
                              {WSPDATA.access_status === "view" ? (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    color: "grey",
                                  }}
                                >
                                  {"Delete"}
                                </span>
                              ) : (
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  // disabled={users.responsibilities==="approver"}
                                  onClick={(e) => {
                                    if (users.responsibilities === "preparer") {
                                      e.stopPropagation();
                                      checkingPermission(WSPID)
                                    } else if (users.responsibilities === "approver" || users.responsibilities === "view") {
                                      e.stopPropagation();
                                    } else {
                                      e.stopPropagation();
                                      handleDelete(WSPID);
                                    }
                                  }}
                                >
                                  <div className="view-options"
                                  >
                                    <img className="icon-img ml-3"
                                      src={deleteIcon}
                                      alt="rename icon"
                                    />
                                    <span className="mt-1 ml-1 font-sans">Delete</span>
                                  </div>
                                </span>
                              )}
                            </Typography>
                          </Popover>
                        </span>

                        <div className={commoncss.dFlexWrap}>
                          {det.selectedModules && det.selectedModules.map((selModule) => {
                            return (
                              <StatusIndicator
                                status="red"
                                label={selModule}
                              />
                            )
                          })}
                        </div>
                      </div>
                      {/* <div>
                      </div> */}
                      <div>
                        {(det.standalone_cy || det.standalone_py) ? (
                          <>
                            <div className={`${cardcss.wsPeriod} w-100`} style={{ padding: "6px" }}>
                              <span className={cardcss.wsLabelSm1}>Current Year</span>
                              {det.standalone_cy && moment(det.standalone_cy).isValid() ? (
                                <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                  {moment(det.standalone_cy).format("MMM DD, YYYY")}
                                </span>
                              ) : (() => {
                                const wsDate = workspaceCy(det.workspace_id, "id");
                                return moment(wsDate).isValid() ? (
                                  <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                    {moment(wsDate).format("MMM DD, YYYY")}
                                  </span>
                                ) : (
                                  <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                );
                              })()}
                            </div>

                            <div className={`${cardcss.wsPeriod} w-100 mt-2`} style={{ padding: "6px" }}>
                              <span className={cardcss.wsLabelSm1}>Previous Year</span>
                              {det.standalone_py && moment(det.standalone_py).isValid() ? (
                                <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                  {moment(det.standalone_py).format("MMM DD, YYYY")}
                                </span>
                              ) : (() => {
                                const wsPrevDate = workspacePy(det.workspace_id, "id");
                                return moment(wsPrevDate).isValid() ? (
                                  <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                    {moment(wsPrevDate).format("MMM DD, YYYY")}
                                  </span>
                                ) : (
                                  <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                );
                              })()}
                            </div>
                          </>
                        ) : (det.book_closure_as_on_date || det.createdAt) ? (
                          <>
                            <div className={`${cardcss.wsPeriod} w-100`} style={{ padding: "6px" }}>
                              <span className={cardcss.wsLabelSm1}>As on Date</span>
                              {det.book_closure_as_on_date && moment(det.book_closure_as_on_date).isValid() ? (
                                <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                  {moment(det.book_closure_as_on_date).format("MMM DD, YYYY")}
                                </span>
                              ) : (
                                <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                              )}
                            </div>
                            <div className={`${cardcss.wsPeriod} w-100 mt-2`} style={{ padding: "6px" }}>
                              <span className={cardcss.wsLabelSm1}>Created At</span>
                              {det.createdAt && moment(det.createdAt).isValid() ? (
                                <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                  {moment(det.createdAt).format("MMM DD, YYYY")}
                                </span>
                              ) : (
                                <>
                                  <div className={`${cardcss.wsPeriod} w-100`} style={{ padding: "6px" }}>
                                    <span className={cardcss.wsLabelSm1}>Current Year</span>
                                    <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                  </div>

                                  <div className={`${cardcss.wsPeriod} w-100 mt-2`} style={{ padding: "6px" }}>
                                    <span className={cardcss.wsLabelSm1}>Previous Year</span>
                                    <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                                  </div>
                                </>
                              )}
                            </div>
                          </>
                        ) : null}

                        {/* <div className={`${cardcss.wsPeriod} w-100`} style={{ "padding": "6px" }}>
                          <span className={cardcss.wsLabelSm1}>Current Year</span>
                          {det.standalone_cy && moment(det.standalone_cy).isValid() ? (
                            <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                              {moment(det.standalone_cy).format("MMM DD, YYYY")}
                            </span>
                          ) : (() => {
                            const wsDate = workspaceCy(det.workspace_id, "id");
                            return moment(wsDate).isValid() ? (
                              <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                {moment(wsDate).format("MMM DD, YYYY")}
                              </span>
                            ) : (
                              <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                            );
                          })()
                          }
                        </div>
                        <div className={`${cardcss.wsPeriod} w-100 mt-2`} style={{ "padding": "6px" }}>
                          <span className={cardcss.wsLabelSm1}>Previous Year</span>
                          {det.standalone_py && moment(det.standalone_py).isValid() ? (
                            <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                              {moment(det.standalone_py).format("MMM DD, YYYY")}
                            </span>
                          ) : (() => {
                            const wsPrevDate = workspacePy(det.workspace_id, "id");
                            return moment(wsPrevDate).isValid() ? (
                              <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>
                                {moment(wsPrevDate).format("MMM DD, YYYY")}
                              </span>
                            ) : (
                              <span className={cardcss.wsLabelSm1} style={{ color: "black" }}>—</span>
                            );
                          })()
                          }
                        </div> */}
                        <div className="mt-1">
                          {det?.workspace_name ?
                            <span className={cardcss.wsLabel2} >{moment(det.createdAt).fromNow()}</span> :
                            <div className={cardcss.wsLabel2}  >
                              Shared by{" "}
                              {UserName(det?.user_id).substring(
                                0,
                                UserName(det?.user_id).lastIndexOf("@")
                              )}
                            </div>}
                        </div>
                      </div>


                    </motion.div>

                  </>
                );
              })}

              {/* <div className="row"> */}
              <div className={cardcss.wsViewAll}>
                <div className={commoncss.dFlex} style={{ cursor: "pointer", marginLeft: "10px", }} onClick={nextWorkspace}>
                  <span className={cardcss.wsViewAllLable}>View all</span>
                  <RightArrowIcon width={20} height={30} style={{ marginLeft: "5px", }} />
                </div>
              </div>
              {/* </div> */}


            </motion.div>
            {/* </div> */}

            {/* <div className="col-2 text-right">
                {allWorkspace.slice(0, 3).length > 2 ? (
                  <div style={{ cursor: "pointer" }} onClick={nextWorkspace}>
                    <div className="myDIV">
                      <ArrowForwardIcon />
                    </div>
                    <div className="hide">View all</div>
                  </div>
                ) : (
                  ""
                )}
              </div>*/}
            {/* </div> */}
            {/* </div> */}
          </div>
        </>
      ) : (
        <div>
          <div style={{ marginTop:"30px" }}>
            {permissions?.companyData[0]?.components[0]?.permission?.create === true || permissions === null ? (
              <span onClick={nextStep} disabled={users.responsibilities === "approver" || users.responsibilities === "view"}>
                <CreateWSCard width="250" height="260" className={commoncss.clickable} onClick={nextStep} />

              </span>
            ) : (
              <span disabled>
                <CreateWSCard width="250" height="260" className={commoncss.filterGreyScale} disabled />
              </span>
            )
            }
          </div>
        </div>
      )}
      <SendRequest
        openRequestModal={openRequestModal}
        handleCloseRequestModal={handleCloseRequestModal}
        companyId={companyId}
        WID={WID}
        WSPDATA={WSPDATA}
      />
      <SendApproval
        user={users}
        approverId={approverId}
        openApproveModal={openApproveModal}
        handleCloseApprovalModal={handleCloseApprovalModal}
        handleApproverChange={handleApproverChange}
        WID={WID}
        WSPDATA={WSPDATA} />
      <Modal
        open={openRenameModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="col-12">
            <h5>Rename Workspace</h5>
            <form>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  defaultValue={workspace(renameId, "id")}
                  onChange={(e) => handleChangeData(e)}
                />
              </div>
              <input
                type="button"
                className="btn btn-primary1"
                value="Submit"
                onClick={submitCompany}
              />
              <input
                type="button"
                className="btn btn-defult"
                value="Close"
                onClick={handleClose}
              />
            </form>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default WorkSpaceData;
